module.exports = "../../../../platform/assets/pageMainIcon/business_danjuweihulei5.svg";